<template>
  <div class="p-4 md:p-6">
    <!-- Encabezado -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
      <div>
        <h1 class="text-2xl font-bold text-gray-800 dark:text-white">Gestión de Pagos</h1>
        <p class="text-sm md:text-base text-gray-600 dark:text-gray-400">Administra todos los pagos del sistema</p>
      </div>
      <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full md:w-auto">
        <!-- BOTÓN DE REPORTE GENERAL -->
        <button
          @click="generarReporteGeneral"
          class="flex items-center justify-center px-3 py-2 md:px-4 md:py-2.5 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-300 shadow-md hover:shadow-lg text-sm md:text-base"
        >
          <Icon icon="mdi:file-document" class="mr-2 text-lg" />
          <span class="hidden sm:inline">Reporte General</span>
          <span class="sm:hidden">Reporte</span>
        </button>

        <!-- BOTÓN NUEVO PAGO -->
        <button
          @click="openCreateModal"
          class="flex items-center justify-center px-3 py-2 md:px-4 md:py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 shadow-md hover:shadow-lg text-sm md:text-base"
        >
          <Icon icon="mdi:plus" class="mr-2 text-lg" />
          <span class="hidden sm:inline">Nuevo Pago</span>
          <span class="sm:hidden">Nuevo</span>
        </button>
      </div>
    </div>

    <!-- Filtros y búsqueda -->
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-3 mb-4 border border-gray-200 dark:border-gray-700">
      <div class="grid grid-cols-12 gap-2">
        <div class="col-span-12 md:col-span-4">
          <label class="block text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Buscar Pagos</label>
          <div class="relative">
            <Icon icon="mdi:magnify" class="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
            <input v-model="searchQuery" type="text" placeholder="Referencia, descripción..."
              class="w-full pl-8 pr-3 py-1.5 border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent text-xs transition-all"
              @input="handleSearch" />
          </div>
        </div>
        <div class="col-span-6 md:col-span-2">
          <label class="block text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Estado</label>
          <div class="relative">
            <select v-model="filterStatus" @change="handleFilterChange"
              class="w-full appearance-none border border-gray-200 dark:border-gray-600 rounded-lg px-2.5 py-1.5 bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 pr-7 text-xs transition-all">
              <option value="all">Todos</option>
              <option value="completado">Completados</option>
              <option value="pendiente">Pendientes</option>
              <option value="anulado">Anulados</option>
            </select>
            <Icon icon="mdi:chevron-down" class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-sm" />
          </div>
        </div>
        <div class="col-span-6 md:col-span-3">
          <label class="block text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Método / Moneda</label>
          <div class="flex gap-1">
            <div class="relative flex-1">
              <select v-model="filterMetodoPago"
                class="w-full appearance-none border border-gray-200 dark:border-gray-600 rounded-lg px-2.5 py-1.5 bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 pr-7 text-xs transition-all">
                <option value="all">Todos métodos</option>
                <option v-for="metodo in metodosPago" :key="metodo.idMetodoPago" :value="metodo.idMetodoPago">
                  {{ metodo.nombre }}
                </option>
              </select>
              <Icon icon="mdi:chevron-down" class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-sm" />
            </div>
            <div class="relative">
              <select v-model="filterMoneda"
                class="appearance-none border border-gray-200 dark:border-gray-600 rounded-lg px-2.5 py-1.5 bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 pr-7 text-xs transition-all">
                <option value="all">Todas</option>
                <option value="USD">USD</option>
                <option value="BS">Bs</option>
              </select>
              <Icon icon="mdi:chevron-down" class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-sm" />
            </div>
          </div>
        </div>
        <div class="col-span-6 md:col-span-3">
          <label class="block text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Desde / Hasta</label>
          <div class="flex gap-1">
            <input v-model="filtroFechaDesde" type="date"
              class="w-1/2 px-2 py-1.5 border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-xs transition-all" />
            <input v-model="filtroFechaHasta" type="date"
              class="w-1/2 px-2 py-1.5 border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-xs transition-all" />
          </div>
        </div>
      </div>

      <!-- BOTONES DE REPORTES POR FILTRO -->
      <div class="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700 flex flex-wrap gap-2">
        <span class="text-sm font-medium text-gray-700 dark:text-gray-300 mr-2 py-2">Reportes rápidos:</span>
        
        <button
          @click="generarReportePorFiltro('completado', 'PAGOS COMPLETADOS')"
          class="px-3 py-1.5 bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded-lg text-xs font-medium hover:bg-green-100 dark:hover:bg-green-800/50 transition-colors border border-green-200 dark:border-green-800"
        >
          <Icon icon="mdi:check-circle" class="mr-1 inline" /> Completados
        </button>
        
        <button
          @click="generarReportePorFiltro('pendiente', 'PAGOS PENDIENTES')"
          class="px-3 py-1.5 bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 rounded-lg text-xs font-medium hover:bg-yellow-100 dark:hover:bg-yellow-800/50 transition-colors border border-yellow-200 dark:border-yellow-800"
        >
          <Icon icon="mdi:clock-outline" class="mr-1 inline" /> Pendientes
        </button>
        
        <button
          @click="generarReportePorFiltro('anulado', 'PAGOS ANULADOS')"
          class="px-3 py-1.5 bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-lg text-xs font-medium hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors border border-red-200 dark:border-red-800"
        >
          <Icon icon="mdi:cancel" class="mr-1 inline" /> Anulados
        </button>
        
        <button
          @click="generarReportePorFiltro('hoy', 'PAGOS DE HOY')"
          class="px-3 py-1.5 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-lg text-xs font-medium hover:bg-blue-100 dark:hover:bg-blue-800/50 transition-colors border border-blue-200 dark:border-blue-800"
        >
          <Icon icon="mdi:calendar-today" class="mr-1 inline" /> Hoy
        </button>
        
        <button
          @click="generarReportePorFiltro('semana', 'PAGOS DE LA SEMANA')"
          class="px-3 py-1.5 bg-purple-50 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 rounded-lg text-xs font-medium hover:bg-purple-100 dark:hover:bg-purple-800/50 transition-colors border border-purple-200 dark:border-purple-800"
        >
          <Icon icon="mdi:calendar-week" class="mr-1 inline" /> Esta Semana
        </button>
        
        <button
          @click="generarReportePorFiltro('mes', 'PAGOS DEL MES')"
          class="px-3 py-1.5 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 rounded-lg text-xs font-medium hover:bg-indigo-100 dark:hover:bg-indigo-800/50 transition-colors border border-indigo-200 dark:border-indigo-800"
        >
          <Icon icon="mdi:calendar-month" class="mr-1 inline" /> Este Mes
        </button>
      </div>
    </div>

    <!-- GRID DE PAGOS -->
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden border border-gray-200 dark:border-gray-700">
      <div class="px-4 md:px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <div>
          <h2 class="text-base md:text-lg font-semibold text-gray-800 dark:text-white">Lista de Pagos</h2>
          <p class="text-xs md:text-sm text-gray-600 dark:text-gray-400">
            Mostrando {{ Math.min(paginatedPagos.length, itemsPerPage) }} de {{ filteredPagos.length }} pagos
          </p>
        </div>
        <div class="flex items-center space-x-2 text-xs md:text-sm text-gray-500 dark:text-gray-400">
          <Icon icon="mdi:calendar" class="inline mr-1 text-sm" />
          <span class="hidden xs:inline">Última actualización:</span> {{ formatTime(lastUpdate) }}
        </div>
      </div>

      <div v-if="loading" class="py-12 md:py-16">
        <div class="flex flex-col items-center justify-center">
          <div class="animate-spin rounded-full h-10 w-10 md:h-12 md:w-12 border-t-2 border-b-2 border-blue-600 mb-4"></div>
          <p class="text-sm md:text-base text-gray-600 dark:text-gray-400">Cargando pagos...</p>
        </div>
      </div>

      <div v-else-if="filteredPagos.length === 0" class="py-12 md:py-16 px-4">
        <div class="flex flex-col items-center text-center">
          <div class="p-4 bg-gray-100 dark:bg-gray-700 rounded-full mb-4">
            <Icon icon="mdi:cash-off" class="text-3xl md:text-4xl text-gray-400" />
          </div>
          <h3 class="text-base md:text-lg font-medium text-gray-800 dark:text-white mb-2">
            No se encontraron pagos
          </h3>
          <p class="text-xs md:text-sm text-gray-600 dark:text-gray-400 mb-6 max-w-md">
            {{ searchQuery || filterStatus !== 'all' || filterMetodoPago !== 'all' || filterMoneda !== 'all' || filtroFechaDesde || filtroFechaHasta
              ? 'Intenta con otros términos de búsqueda o cambia los filtros.' 
              : 'No hay pagos registrados. ¡Registra el primero!' }}
          </p>
          <button
            v-if="!searchQuery && filterStatus === 'all' && filterMetodoPago === 'all' && filterMoneda === 'all' && !filtroFechaDesde && !filtroFechaHasta"
            @click="openCreateModal"
            class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
          >
            <Icon icon="mdi:plus" class="mr-2 inline" />
            Registrar primer pago
          </button>
          <button
            v-else
            @click="clearFilters"
            class="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors text-sm"
          >
            <Icon icon="mdi:filter-off" class="mr-2 inline" />
            Limpiar filtros
          </button>
        </div>
      </div>

      <div v-else class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead class="bg-gray-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">
            <tr>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">ID</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Fecha</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Referencia</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Tipo</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Método</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Monto</th>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Estado</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Usuario</th>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
            <tr v-for="pago in paginatedPagos" :key="pago.idPago" class="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
              <td class="px-4 py-3 text-xs text-gray-800 dark:text-white">#{{ pago.idPago }}</td>
              <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-300">
                {{ formatDate(pago.fecha_pago, true) }}
              </td>
              <td class="px-4 py-3 text-xs font-medium text-gray-800 dark:text-white">
                {{ pago.referencia || '—' }}
              </td>
              <td class="px-4 py-3 text-xs">
                <span :class="[
                  'px-2 py-1 rounded-full text-xs font-medium',
                  getTipoPagoClass(pago.tipoPago)
                ]">
                  {{ pago.tipoPago }}
                </span>
              </td>
              <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-300">
                {{ pago.metodo_pago || '—' }}
              </td>
              <td class="px-4 py-3 text-right">
                <div class="text-xs font-medium text-gray-800 dark:text-white">
                  {{ formatNumber(pago.monto_usd) }} USD
                </div>
                <div class="text-xs text-gray-500 dark:text-gray-400">
                  {{ formatNumber(pago.monto_bs) }} Bs
                </div>
                <div class="text-xs text-gray-400 dark:text-gray-500">
                  (Original: {{ pago.moneda_original }})
                </div>
              </td>
              <td class="px-4 py-3 text-center">
                <span
                  @click="abrirModalToggleEstado(pago)"
                  :class="[
                    'px-2 py-1 text-xs font-semibold rounded-full cursor-pointer inline-flex items-center',
                    getEstadoClass(pago.estado)
                  ]"
                >
                  <Icon :icon="getEstadoIcon(pago.estado)" class="mr-1 text-xs" />
                  {{ pago.estado }}
                </span>
              </td>
              <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-300">
                {{ pago.usuario || '—' }}
              </td>
              <td class="px-4 py-3">
                <div class="flex items-center justify-center space-x-1">
                  <button
                    @click.stop="abrirModalVerDetalles(pago)"
                    class="p-2 bg-purple-50 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-800/50 transition-colors"
                    title="Ver detalles"
                  >
                    <Icon icon="mdi:eye" class="text-base" />
                  </button>
                  <button
                    v-if="pago.estado?.toLowerCase() !== 'anulado'"
                    @click.stop="abrirModalAnular(pago)"
                    class="p-2 bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors"
                    title="Anular pago"
                  >
                    <Icon icon="mdi:cancel" class="text-base" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Paginación Premium -->
        <div v-if="filteredPagos.length > itemsPerPage" class="px-4 py-3 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div class="text-xs text-gray-500 dark:text-gray-400 order-2 sm:order-1">
            Mostrando <span class="font-semibold text-gray-700 dark:text-gray-300">{{ startItem }}–{{ Math.min(endItem, filteredPagos.length) }}</span> de <span class="font-semibold text-gray-700 dark:text-gray-300">{{ filteredPagos.length }}</span>
          </div>
          <div class="flex items-center gap-1 order-1 sm:order-2">
            <button @click="currentPage = Math.max(currentPage - 1, 1)" :disabled="currentPage === 1"
              class="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 text-gray-500 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all">
              <Icon icon="mdi:chevron-left" class="text-base" />
            </button>
            <button v-for="page in visiblePages" :key="page" @click="currentPage = page"
              :class="['w-8 h-8 flex items-center justify-center rounded-lg text-xs font-semibold transition-all',
                currentPage === page
                  ? 'bg-blue-600 text-white shadow-sm shadow-blue-300 dark:shadow-blue-900'
                  : 'border border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700']">{{ page }}</button>
            <button @click="currentPage = Math.min(currentPage + 1, totalPages)" :disabled="currentPage === totalPages"
              class="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 text-gray-500 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all">
              <Icon icon="mdi:chevron-right" class="text-base" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL PARA CREAR PAGO -->
    <Teleport to="body">
    <div v-if="showModal" class="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[90] backdrop-blur-[2px]">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-2xl transform transition-all duration-300 scale-100 max-h-[90vh] overflow-hidden mx-auto my-auto">
        <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <div class="p-2 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 shadow-md mr-3">
                <Icon icon="mdi:cash-plus" class="text-white text-xl" />
              </div>
              <div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white">Nuevo Pago</h3>
                <p class="text-xs text-gray-600 dark:text-gray-400">Completa los datos para registrar un nuevo pago</p>
              </div>
            </div>
            <button 
              @click="closeModal"
              class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            >
              <Icon icon="mdi:close" class="text-xl" />
            </button>
          </div>
        </div>
        
        <form @submit.prevent="crearPago" class="px-6 py-4 overflow-y-auto max-h-[calc(90vh-130px)]">
          <div class="space-y-4">
            <!-- Tipo de referencia -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Asociado a <span class="text-red-500">*</span>
              </label>
              <div class="grid grid-cols-3 gap-2">
                <button
                  type="button"
                  @click="form.tipoReferencia = 'venta'"
                  :class="[
                    'px-3 py-2 rounded-lg border text-sm font-medium transition-colors',
                    form.tipoReferencia === 'venta'
                      ? 'bg-blue-600 text-white border-blue-600'
                      : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600'
                  ]"
                >
                  <Icon icon="mdi:cart" class="mr-1 inline" />
                  Venta
                </button>
                <button
                  type="button"
                  @click="form.tipoReferencia = 'cuota'"
                  :class="[
                    'px-3 py-2 rounded-lg border text-sm font-medium transition-colors',
                    form.tipoReferencia === 'cuota'
                      ? 'bg-blue-600 text-white border-blue-600'
                      : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600'
                  ]"
                >
                  <Icon icon="mdi:calendar-clock" class="mr-1 inline" />
                  Cuota
                </button>
                <button
                  type="button"
                  @click="form.tipoReferencia = 'recepcion'"
                  :class="[
                    'px-3 py-2 rounded-lg border text-sm font-medium transition-colors',
                    form.tipoReferencia === 'recepcion'
                      ? 'bg-blue-600 text-white border-blue-600'
                      : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600'
                  ]"
                >
                  <Icon icon="mdi:tools" class="mr-1 inline" />
                  Recepción
                </button>
              </div>
            </div>

            <!-- ID de referencia según tipo -->
            <div v-if="form.tipoReferencia">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                {{ getReferenciaLabel }} <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.idReferencia"
                type="number"
                required
                min="1"
                class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                :placeholder="`ID de la ${getReferenciaLabel.toLowerCase()}`"
              />
            </div>

            <!-- Monto y moneda -->
            <div class="grid grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Monto <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="form.monto"
                  type="number"
                  step="0.01"
                  min="0.01"
                  required
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="0.00"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Moneda <span class="text-red-500">*</span>
                </label>
                <select
                  v-model="form.moneda"
                  required
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                >
                  <option value="USD">USD - Dólar</option>
                  <option value="BS">BS - Bolívar</option>
                </select>
              </div>
            </div>

            <!-- Referencia y descripción -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Número de Referencia
              </label>
              <input
                v-model="form.referencia"
                type="text"
                maxlength="100"
                class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                placeholder="Ej: TRANS-001 (opcional)"
              />
              <p class="mt-1 text-xs text-gray-500">Si no se proporciona, se generará automáticamente</p>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Descripción
              </label>
              <textarea
                v-model="form.descripcion"
                rows="2"
                maxlength="500"
                class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 resize-none text-sm"
                placeholder="Descripción del pago..."
              ></textarea>
            </div>

            <!-- Método de pago -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Método de Pago <span class="text-red-500">*</span>
              </label>
              <select
                v-model="form.idMetodoPago"
                required
                class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
              >
                <option value="">Seleccionar método...</option>
                <option v-for="metodo in metodosPago" :key="metodo.idMetodoPago" :value="metodo.idMetodoPago">
                  {{ metodo.nombre }}
                </option>
              </select>
            </div>

            <!-- Fecha de pago -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Fecha de Pago
              </label>
              <input
                v-model="form.fecha_pago"
                type="datetime-local"
                class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
              />
              <p class="mt-1 text-xs text-gray-500">Si no se especifica, se usará la fecha actual</p>
            </div>

            <!-- Fuente de tasa (opcional) -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Fuente de Tasa (opcional)
              </label>
              <select
                v-model="form.idFuenteTasa"
                class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
              >
                <option :value="null">Usar fuente activa por defecto</option>
                <option value="1">BCV</option>
                <option value="2">Paralelo</option>
                <option value="3">Promedio</option>
              </select>
            </div>

            <!-- Campos específicos según método de pago (se mostrarían aquí) -->
          </div>
          
          <div class="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              @click="closeModal"
              class="px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-300 text-sm"
            >
              Cancelar
            </button>
            <button
              type="submit"
              :disabled="saving || !isFormValid"
              class="px-4 py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-medium hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
            >
              <Icon v-if="saving" icon="mdi:loading" class="animate-spin mr-2 inline" />
              {{ saving ? 'Guardando...' : 'Registrar Pago' }}
            </button>
          </div>
        </form>
      </div>
    </div>
    </Teleport>

    <!-- MODAL DE DETALLES DEL PAGO -->
    <Teleport to="body">
    <div v-if="showDetallesModal" class="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[90] backdrop-blur-[2px]">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-3xl transform transition-all duration-300 scale-100 max-h-[90vh] overflow-hidden mx-auto my-auto">
        <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-purple-600 to-indigo-600">
          <div class="flex items-center justify-between">
            <div class="flex items-center text-white">
              <Icon icon="mdi:cash" class="text-2xl mr-3" />
              <div>
                <h3 class="text-lg font-bold">Detalles del Pago #{{ detallePago?.idPago }}</h3>
                <p class="text-xs text-purple-100">{{ detallePago?.referencia }}</p>
              </div>
            </div>
            <button @click="closeDetallesModal" class="p-2 hover:bg-white/30 text-white rounded-lg transition-colors">
              <Icon icon="mdi:close" class="text-xl" />
            </button>
          </div>
        </div>

        <div class="px-6 py-4 overflow-y-auto max-h-[calc(90vh-130px)]">
          <div v-if="cargandoDetalles" class="flex justify-center py-8">
            <div class="animate-spin rounded-full h-8 w-8 border-2 border-blue-600 border-t-transparent"></div>
          </div>
          <div v-else-if="detallePago" class="space-y-4">
            <!-- Información básica -->
            <div class="grid grid-cols-3 gap-4">
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">ID Pago</p>
                <p class="text-sm font-semibold">#{{ detallePago.idPago }}</p>
              </div>
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">Estado</p>
                <p class="text-sm">
                  <span :class="['px-2 py-1 text-xs font-semibold rounded-full inline-block', getEstadoClass(detallePago.estado)]">
                    {{ detallePago.estado }}
                  </span>
                </p>
              </div>
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">Tipo</p>
                <p class="text-sm font-semibold">{{ detallePago.tipoPago }}</p>
              </div>
            </div>

            <!-- Fechas -->
            <div class="grid grid-cols-2 gap-4">
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">Fecha de Pago</p>
                <p class="text-sm">{{ formatDate(detallePago.fecha_pago, true) }}</p>
              </div>
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">Fecha de Creación</p>
                <p class="text-sm">{{ formatDate(detallePago.fecha_creacion, true) }}</p>
              </div>
            </div>

            <!-- Montos -->
            <div class="p-4 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
              <p class="text-xs text-blue-600 dark:text-blue-400 mb-2">Detalle de Montos</p>
              <div class="grid grid-cols-3 gap-4 text-center">
                <div>
                  <p class="text-xs text-gray-500 dark:text-gray-400">Monto Original</p>
                  <p class="text-sm font-semibold">{{ detallePago.monto_original }} {{ detallePago.moneda_original }}</p>
                </div>
                <div>
                  <p class="text-xs text-gray-500 dark:text-gray-400">USD</p>
                  <p class="text-sm font-semibold text-green-600">${{ formatNumber(detallePago.monto_usd) }}</p>
                </div>
                <div>
                  <p class="text-xs text-gray-500 dark:text-gray-400">BS</p>
                  <p class="text-sm font-semibold text-blue-600">Bs {{ formatNumber(detallePago.monto_bs) }}</p>
                </div>
              </div>
              <div class="mt-2 text-xs text-gray-500 text-center">
                Tasa usada: {{ formatNumber(detallePago.tasa_usada, 4) }}
              </div>
            </div>

            <!-- Referencia y descripción -->
            <div class="grid grid-cols-2 gap-4">
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">Referencia</p>
                <p class="text-sm font-medium">{{ detallePago.referencia || '—' }}</p>
              </div>
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">Método de Pago</p>
                <p class="text-sm">{{ detallePago.nombreMetodoPago || detallePago.metodo_pago }}</p>
              </div>
            </div>

            <div v-if="detallePago.descripcion" class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Descripción</p>
              <p class="text-sm">{{ detallePago.descripcion }}</p>
            </div>

            <!-- Asociación -->
            <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Asociado a</p>
              <div class="space-y-1">
                <div v-if="detallePago.idVenta" class="flex items-center text-sm">
                  <Icon icon="mdi:cart" class="mr-2 text-blue-600" />
                  <span>Venta #{{ detallePago.idVenta }}</span>
                  <span v-if="detallePago.numeroFactura" class="ml-2 text-xs text-gray-500">({{ detallePago.numeroFactura }})</span>
                </div>
                <div v-else-if="detallePago.idCuota" class="flex items-center text-sm">
                  <Icon icon="mdi:calendar-clock" class="mr-2 text-purple-600" />
                  <span>Cuota #{{ detallePago.idCuota }}</span>
                  <span v-if="detallePago.numeroCuota" class="ml-2 text-xs text-gray-500">(Cuota {{ detallePago.numeroCuota }})</span>
                </div>
                <div v-else-if="detallePago.idRecepcionEquipo" class="flex items-center text-sm">
                  <Icon icon="mdi:tools" class="mr-2 text-green-600" />
                  <span>Recepción de Equipo #{{ detallePago.idRecepcionEquipo }}</span>
                  <span v-if="detallePago.codigoRecepcion" class="ml-2 text-xs text-gray-500">({{ detallePago.codigoRecepcion }})</span>
                </div>
              </div>
            </div>

            <!-- Cliente -->
            <div v-if="detallePago.clienteNombre" class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Cliente</p>
              <p class="text-sm font-medium">{{ detallePago.clienteNombre }}</p>
              <p v-if="detallePago.clienteDocumento" class="text-xs text-gray-500">Doc: {{ detallePago.clienteDocumento }}</p>
            </div>

            <!-- Usuario que registró -->
            <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Registrado por</p>
              <p class="text-sm">{{ detallePago.nombreUsuario || detallePago.usuario }}</p>
            </div>

            <!-- Tasas de cambio -->
            <div v-if="detallePago.idTasaVenta || detallePago.idTasaCompra" class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Tasas de Cambio</p>
              <div class="grid grid-cols-2 gap-4">
                <div v-if="detallePago.idTasaVenta">
                  <p class="text-xs">Tasa Venta ID: {{ detallePago.idTasaVenta }}</p>
                  <p class="text-xs text-gray-500">{{ formatDate(detallePago.fechaTasaVenta) }}</p>
                </div>
                <div v-if="detallePago.idTasaCompra">
                  <p class="text-xs">Tasa Compra ID: {{ detallePago.idTasaCompra }}</p>
                  <p class="text-xs text-gray-500">{{ formatDate(detallePago.fechaTasaCompra) }}</p>
                </div>
              </div>
            </div>

            <!-- Historial de cambios -->
            <div v-if="detallePago.historialCambios && detallePago.historialCambios.length > 0" class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Historial de Cambios</p>
              <div class="space-y-2">
                <div v-for="(cambio, index) in detallePago.historialCambios" :key="index" class="text-xs border-l-2 border-gray-300 pl-2">
                  <p class="font-medium">{{ formatDate(cambio.fecha_cambio, true) }}</p>
                  <p>De: {{ cambio.valor_anterior || '—' }} → A: {{ cambio.valor_nuevo }}</p>
                  <p v-if="cambio.observaciones" class="text-gray-500">{{ cambio.observaciones }}</p>
                  <p class="text-gray-500">Por: {{ cambio.usuario }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 flex justify-end">
          <button
            @click="closeDetallesModal"
            class="px-4 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-300 text-sm"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
    </Teleport>

    <!-- MODAL DE REPORTE -->
    <Teleport to="body">
    <div v-if="showReportModal" class="fixed inset-0 bg-black/80 flex items-center justify-center p-4 z-[100] backdrop-blur-[2px]" @click.self="closeReportModal">
      <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-6xl transform transition-all duration-300 scale-100 max-h-[95vh] overflow-hidden mx-auto my-auto flex flex-col">
        <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-green-600 to-emerald-600 flex justify-between items-center">
          <div class="flex items-center text-white">
            <Icon icon="mdi:file-document" class="text-2xl mr-3" />
            <div>
              <h3 class="text-xl font-bold">{{ reporteTitulo }}</h3>
              <p class="text-xs text-green-100">{{ reporteSubtitulo }} • {{ reportePagos.length }} pagos</p>
            </div>
          </div>
          <button @click="closeReportModal" class="p-2 hover:bg-white/30 text-white rounded-lg transition-colors">
            <Icon icon="mdi:close" class="text-2xl" />
          </button>
        </div>

        <div class="px-6 pt-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
          <div class="flex space-x-4">
            <button
              @click="reporteVista = 'lista'"
              :class="[
                'px-4 py-2 text-sm font-medium rounded-t-lg transition-colors',
                reporteVista === 'lista'
                  ? 'bg-white dark:bg-gray-900 text-green-600 dark:text-green-400 border-b-2 border-green-600'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              ]"
            >
              <Icon icon="mdi:format-list-bulleted" class="mr-2 inline" />
              Vista Lista
            </button>
            <button
              @click="reporteVista = 'resumen'"
              :class="[
                'px-4 py-2 text-sm font-medium rounded-t-lg transition-colors',
                reporteVista === 'resumen'
                  ? 'bg-white dark:bg-gray-900 text-green-600 dark:text-green-400 border-b-2 border-green-600'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              ]"
            >
              <Icon icon="mdi:chart-bar" class="mr-2 inline" />
              Vista Resumen
            </button>
          </div>
        </div>

        <div class="flex-1 overflow-y-auto p-6 bg-gray-50 dark:bg-gray-800">
          <div v-if="reporteCargando" class="flex items-center justify-center py-20">
            <div class="animate-spin rounded-full h-12 w-12 border-4 border-green-600 border-t-transparent"></div>
            <p class="ml-4 text-gray-600 dark:text-gray-400">Generando reporte...</p>
          </div>
          <div v-else-if="reportePagos.length === 0" class="text-center py-20 text-gray-500">
            No hay pagos para mostrar en este reporte.
          </div>
          <div v-else>
            <div v-if="reporteVista === 'lista'" class="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
              <table class="w-full text-sm">
                <thead class="bg-gray-100 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
                  <tr>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">ID</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Fecha</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Referencia</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Tipo</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Método</th>
                    <th class="px-4 py-3 text-right text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Monto USD</th>
                    <th class="px-4 py-3 text-right text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Monto BS</th>
                    <th class="px-4 py-3 text-center text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Estado</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
                  <tr v-for="pago in reportePagos" :key="pago.idPago" class="hover:bg-gray-50 dark:hover:bg-gray-800/50">
                    <td class="px-4 py-3 text-xs">#{{ pago.idPago }}</td>
                    <td class="px-4 py-3 text-xs">{{ formatDate(pago.fecha_pago) }}</td>
                    <td class="px-4 py-3 text-xs">{{ pago.referencia || '—' }}</td>
                    <td class="px-4 py-3 text-xs">
                      <span :class="['px-2 py-1 rounded-full text-xs', getTipoPagoClass(pago.tipoPago)]">
                        {{ pago.tipoPago }}
                      </span>
                    </td>
                    <td class="px-4 py-3 text-xs">{{ pago.metodo_pago }}</td>
                    <td class="px-4 py-3 text-right text-xs font-medium">${{ formatNumber(pago.monto_usd) }}</td>
                    <td class="px-4 py-3 text-right text-xs">Bs {{ formatNumber(pago.monto_bs) }}</td>
                    <td class="px-4 py-3 text-center">
                      <span :class="['px-2 py-1 text-xs font-semibold rounded-full', getEstadoClass(pago.estado)]">
                        {{ pago.estado }}
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tfoot class="bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
                  <tr>
                    <td colspan="5" class="px-4 py-3 text-right font-medium">Totales:</td>
                    <td class="px-4 py-3 text-right font-bold">${{ formatNumber(totalUSD) }}</td>
                    <td class="px-4 py-3 text-right font-bold">Bs {{ formatNumber(totalBS) }}</td>
                    <td class="px-4 py-3"></td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div v-else class="space-y-6">
              <!-- Resumen de totales -->
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div class="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                  <p class="text-xs text-gray-500 dark:text-gray-400">Total Pagos</p>
                  <p class="text-2xl font-bold">{{ reportePagos.length }}</p>
                </div>
                <div class="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                  <p class="text-xs text-gray-500 dark:text-gray-400">Total USD</p>
                  <p class="text-2xl font-bold text-green-600">${{ formatNumber(totalUSD) }}</p>
                </div>
                <div class="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                  <p class="text-xs text-gray-500 dark:text-gray-400">Total BS</p>
                  <p class="text-2xl font-bold text-blue-600">Bs {{ formatNumber(totalBS) }}</p>
                </div>
              </div>

              <!-- Resumen por método -->
              <div class="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                <h4 class="text-sm font-semibold mb-3">Resumen por Método de Pago</h4>
                <div class="space-y-2">
                  <div v-for="(item, index) in resumenPorMetodo" :key="index" class="flex items-center justify-between text-sm">
                    <span>{{ item.metodo }}</span>
                    <span class="font-medium">{{ item.cantidad }} pagos - ${{ formatNumber(item.totalUSD) }}</span>
                  </div>
                </div>
              </div>

              <!-- Resumen por estado -->
              <div class="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                <h4 class="text-sm font-semibold mb-3">Resumen por Estado</h4>
                <div class="grid grid-cols-3 gap-2">
                  <div v-for="(cantidad, estado) in resumenPorEstado" :key="estado" class="text-center p-2 rounded-lg" :class="getEstadoBgClass(estado)">
                    <p class="text-xs text-gray-500">{{ estado }}</p>
                    <p class="text-lg font-bold">{{ cantidad }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 flex justify-between items-center">
          <div class="text-xs text-gray-500">
            <Icon icon="mdi:information" class="inline mr-1" />
            Reporte generado el {{ formatDate(new Date(), true) }}
          </div>
          <div class="flex space-x-3">
            <button
              @click="closeReportModal"
              class="px-4 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-300 text-sm"
            >
              Cerrar
            </button>
            <button
              @click="imprimirReporte"
              class="px-4 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg font-medium hover:from-green-700 hover:to-emerald-700 transition-all duration-300 text-sm flex items-center"
            >
              <Icon icon="mdi:printer" class="mr-2 text-lg" />
              Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DE CONFIRMACIÓN (ANULAR PAGO) -->
    <div v-if="showConfirmModal" class="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-[150]" @click.self="cancelarConfirmacion">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md transform transition-all duration-300 scale-100 mx-auto my-auto overflow-hidden">
        <div class="px-6 py-4" :class="confirmModalColor">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-white bg-opacity-30 mr-4">
              <Icon :icon="confirmModalIcon" class="text-white text-2xl" />
            </div>
            <div>
              <h3 class="text-lg font-bold text-white">{{ confirmModalTitulo }}</h3>
              <p class="text-sm text-white text-opacity-90">{{ confirmModalSubtitulo }}</p>
            </div>
          </div>
        </div>
        
        <div class="px-6 py-5">
          <p class="text-gray-700 dark:text-gray-300 mb-2">{{ confirmModalMensaje }}</p>
          <p v-if="confirmModalDetalle" class="text-sm text-gray-500 dark:text-gray-400 mb-4">{{ confirmModalDetalle }}</p>

          <div v-if="confirmModalTipo === 'anular' && confirmModalPago" class="mb-4 p-3 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
            <div class="flex items-center mb-2">
              <Icon icon="mdi:cash" class="text-red-600 dark:text-red-400 text-xl mr-2" />
              <div>
                <p class="font-medium text-gray-900 dark:text-white">Pago #{{ confirmModalPago.idPago }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Referencia: {{ confirmModalPago.referencia || 'N/A' }}</p>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-2 text-xs">
              <div>
                <p class="text-gray-500">Monto USD</p>
                <p class="font-medium">${{ formatNumber(confirmModalPago.monto_usd) }}</p>
              </div>
              <div>
                <p class="text-gray-500">Monto BS</p>
                <p class="font-medium">Bs {{ formatNumber(confirmModalPago.monto_bs) }}</p>
              </div>
            </div>
            
            <div class="mt-3">
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                Motivo de la anulación <span class="text-red-500">*</span>
              </label>
              <textarea
                v-model="motivoAnulacion"
                rows="2"
                required
                class="w-full px-3 py-2 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 focus:ring-2 focus:ring-red-500 focus:border-transparent"
                placeholder="Indique el motivo de la anulación..."
              ></textarea>
            </div>
            
            <div class="mt-3 flex items-center">
              <input
                v-model="reversarEfecto"
                type="checkbox"
                id="reversarEfecto"
                class="rounded border-gray-300 text-red-600 focus:ring-red-500 mr-2"
              />
              <label for="reversarEfecto" class="text-xs text-gray-700 dark:text-gray-300">
                Reversar efecto en la cuota (si aplica)
              </label>
            </div>
            
            <p class="mt-2 text-xs text-red-600 dark:text-red-400">
              <Icon icon="mdi:alert" class="inline mr-1" />
              Esta acción no se puede deshacer
            </p>
          </div>

          <div v-if="confirmModalTipo === 'toggle-estado' && confirmModalPago" class="mb-4 p-3 rounded-lg" :class="confirmModalPago.estado?.toLowerCase() === 'completado' ? 'bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800' : 'bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800'">
            <div class="flex items-center">
              <Icon :icon="getEstadoIcon(confirmModalPago.estado)" class="text-xl mr-2" :class="getEstadoTextClass(confirmModalPago.estado)" />
              <div>
                <p class="font-medium text-gray-900 dark:text-white">Pago #{{ confirmModalPago.idPago }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Estado actual: {{ confirmModalPago.estado }}</p>
              </div>
            </div>
            <p class="mt-2 text-xs">
              El pago pasará a estado: 
              <span class="font-semibold" :class="getNuevoEstadoClass(confirmModalPago.estado)">
                {{ getNuevoEstado(confirmModalPago.estado) }}
              </span>
            </p>
          </div>
        </div>
        
        <div class="px-6 py-4 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-3">
          <button
            @click="cancelarConfirmacion"
            class="px-4 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-300 text-sm"
          >
            Cancelar
          </button>
          <button
            @click="ejecutarAccionConfirmada"
            :disabled="(confirmModalTipo === 'anular' && !motivoAnulacion) || confirmModalCargando"
            class="px-4 py-2 rounded-lg text-white font-medium transition-all duration-300 text-sm flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
            :class="confirmModalButtonColor"
          >
            <Icon v-if="confirmModalCargando" icon="mdi:loading" class="animate-spin mr-2" />
            {{ confirmModalCargando ? 'Procesando...' : confirmModalBotonTexto }}
          </button>
        </div>
      </div>
    </div>
    </Teleport>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { debounce } from 'lodash';
import { useToast } from "vue-toastification";

// APIs de pagos
import {
  obtenerPagos,
  obtenerPagoPorId,
  crearPago,
  actualizarPago,
  anularPago,
  pagoExists,
  buscarPagos,
  obtenerPagosPorVenta,
  obtenerPagosPorCuota,
  obtenerPagosPorRecepcion,
  obtenerPagosPorCliente,
  obtenerPagosPorUsuario,
  obtenerPagosPorMetodoPago,
  obtenerPagosPorEstado,
  obtenerPagosPorRangoFechas,
  convertirMoneda,
  obtenerTasaCambio,
  obtenerEstadisticas,
  obtenerTotalesPorPeriodo,
  obtenerMetodosMasUsados,
  validarAnulacionPago,
  obtenerMetodosPago
} from '@/api/pagos.js';

export default {
  name: 'PagosView',
  components: {
    Icon,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      // Datos principales
      pagos: [],
      metodosPago: [],
      detallePago: null,

      // UI States
      loading: false,
      saving: false,
      cargandoDetalles: false,
      showModal: false,
      showDetallesModal: false,
      showReportModal: false,
      showConfirmModal: false,
      reporteCargando: false,
      reportePagos: [],
      reporteTitulo: '',
      reporteSubtitulo: '',
      reporteVista: 'lista',

      // Filtros y búsqueda
      searchQuery: '',
      filterStatus: 'all',
      filterMetodoPago: 'all',
      filterMoneda: 'all',
      filtroFechaDesde: '',
      filtroFechaHasta: '',
      sortBy: 'fecha_desc',
      currentPage: 1,
      itemsPerPage: 10,
      lastUpdate: new Date(),

      // Formulario de creación
      form: {
        tipoReferencia: null,
        idReferencia: null,
        monto: null,
        moneda: 'USD',
        referencia: '',
        descripcion: '',
        idMetodoPago: '',
        fecha_pago: '',
        idFuenteTasa: null
      },

      // Modal de confirmación
      confirmModalTipo: '',
      confirmModalTitulo: '',
      confirmModalSubtitulo: '',
      confirmModalMensaje: '',
      confirmModalDetalle: '',
      confirmModalIcon: '',
      confirmModalColor: '',
      confirmModalButtonColor: '',
      confirmModalBotonTexto: '',
      confirmModalPago: null,
      confirmModalCargando: false,
      confirmModalAccion: null,
      
      // Datos específicos para anulación
      motivoAnulacion: '',
      reversarEfecto: false
    };
  },
  computed: {
    filteredPagos() {
      let filtered = [...this.pagos];

      // Búsqueda por texto
      if (this.searchQuery.trim()) {
        const terminoLower = this.searchQuery.toLowerCase();
        filtered = filtered.filter(pago => 
          (pago.referencia && pago.referencia.toLowerCase().includes(terminoLower)) ||
          (pago.descripcion && pago.descripcion?.toLowerCase().includes(terminoLower)) ||
          (pago.metodo_pago && pago.metodo_pago.toLowerCase().includes(terminoLower)) ||
          (pago.usuario && pago.usuario.toLowerCase().includes(terminoLower))
        );
      }

      // Filtro por estado
      if (this.filterStatus !== 'all') {
        filtered = filtered.filter(p => p.estado?.toLowerCase() === this.filterStatus.toLowerCase());
      }

      // Filtro por método de pago
      if (this.filterMetodoPago !== 'all') {
        filtered = filtered.filter(p => p.idMetodoPago === parseInt(this.filterMetodoPago));
      }

      // Filtro por moneda original
      if (this.filterMoneda !== 'all') {
        filtered = filtered.filter(p => p.moneda_original === this.filterMoneda);
      }

      // Filtro por rango de fechas
      if (this.filtroFechaDesde) {
        const desde = new Date(this.filtroFechaDesde);
        desde.setHours(0, 0, 0, 0);
        filtered = filtered.filter(p => new Date(p.fecha_pago) >= desde);
      }
      if (this.filtroFechaHasta) {
        const hasta = new Date(this.filtroFechaHasta);
        hasta.setHours(23, 59, 59, 999);
        filtered = filtered.filter(p => new Date(p.fecha_pago) <= hasta);
      }

      // Ordenar
      if (this.sortBy === 'fecha_desc') {
        filtered.sort((a, b) => new Date(b.fecha_pago) - new Date(a.fecha_pago));
      } else if (this.sortBy === 'fecha_asc') {
        filtered.sort((a, b) => new Date(a.fecha_pago) - new Date(b.fecha_pago));
      } else if (this.sortBy === 'monto_desc') {
        filtered.sort((a, b) => b.monto_usd - a.monto_usd);
      } else if (this.sortBy === 'monto_asc') {
        filtered.sort((a, b) => a.monto_usd - b.monto_usd);
      }

      return filtered;
    },

    paginatedPagos() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredPagos.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredPagos.length / this.itemsPerPage);
    },

    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },

    startItem() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },

    endItem() {
      return Math.min(this.currentPage * this.itemsPerPage, this.filteredPagos.length);
    },

    getReferenciaLabel() {
      if (this.form.tipoReferencia === 'venta') return 'ID de Venta';
      if (this.form.tipoReferencia === 'cuota') return 'ID de Cuota';
      if (this.form.tipoReferencia === 'recepcion') return 'ID de Recepción';
      return '';
    },

    isFormValid() {
      return this.form.tipoReferencia && 
             this.form.idReferencia && 
             this.form.monto > 0 && 
             this.form.moneda && 
             this.form.idMetodoPago;
    },

    // Totales para reportes
    totalUSD() {
      return this.reportePagos.reduce((sum, p) => sum + (p.monto_usd || 0), 0);
    },

    totalBS() {
      return this.reportePagos.reduce((sum, p) => sum + (p.monto_bs || 0), 0);
    },

    resumenPorMetodo() {
      const resumen = {};
      this.reportePagos.forEach(p => {
        const metodo = p.metodo_pago || 'Sin método';
        if (!resumen[metodo]) {
          resumen[metodo] = { cantidad: 0, totalUSD: 0 };
        }
        resumen[metodo].cantidad++;
        resumen[metodo].totalUSD += p.monto_usd || 0;
      });
      return Object.entries(resumen).map(([metodo, data]) => ({
        metodo,
        cantidad: data.cantidad,
        totalUSD: data.totalUSD
      }));
    },

    resumenPorEstado() {
      const resumen = {};
      this.reportePagos.forEach(p => {
        const estado = p.estado || 'Desconocido';
        resumen[estado] = (resumen[estado] || 0) + 1;
      });
      return resumen;
    }
  },
  watch: {
    filterStatus() {
      this.currentPage = 1;
    },
    filterMetodoPago() {
      this.currentPage = 1;
    },
    filterMoneda() {
      this.currentPage = 1;
    },
    searchQuery() {
      this.currentPage = 1;
    },
    filtroFechaDesde() {
      this.currentPage = 1;
    },
    filtroFechaHasta() {
      this.currentPage = 1;
    },
  },
  async mounted() {
    await this.cargarMetodosPago();
    await this.loadData();
  },
  methods: {
    // ========== MÉTODOS DE CARGA DE DATOS ==========
    async loadData() {
      this.loading = true;
      try {
        const response = await obtenerPagos();
        
        if (response.success) {
          this.pagos = response.data || [];
          this.lastUpdate = new Date();
        } else {
          this.mostrarError(response.error || 'Error al cargar los pagos');
        }
      } catch (error) {
        console.error('Error al cargar datos:', error);
        this.mostrarError('Error al cargar los datos');
      } finally {
        this.loading = false;
      }
    },

    async cargarMetodosPago() {
      try {
        const response = await obtenerMetodosPago();
        if (response.success) {
          this.metodosPago = response.data || [];
        }
      } catch (error) {
        console.error('Error cargando métodos de pago:', error);
      }
    },

    async cargarDetallesCompletos(id) {
      this.cargandoDetalles = true;
      try {
        const response = await obtenerPagoPorId(id);
        if (response.success) {
          this.detallePago = response.data;
        }
      } catch (error) {
        console.error('Error cargando detalles:', error);
        this.mostrarError('Error al cargar los detalles');
      } finally {
        this.cargandoDetalles = false;
      }
    },

    // ========== MÉTODOS DE CONFIRMACIÓN ==========
    abrirModalConfirmacion(config) {
      this.confirmModalTipo = config.tipo;
      this.confirmModalTitulo = config.titulo;
      this.confirmModalSubtitulo = config.subtitulo || '';
      this.confirmModalMensaje = config.mensaje;
      this.confirmModalDetalle = config.detalle || '';
      this.confirmModalIcon = config.icon || 'mdi:help-circle';
      this.confirmModalColor = config.color || 'bg-gradient-to-r from-blue-600 to-indigo-600';
      this.confirmModalButtonColor = config.buttonColor || 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700';
      this.confirmModalBotonTexto = config.botonTexto || 'Confirmar';
      this.confirmModalPago = config.pago || null;
      this.confirmModalAccion = config.accion;
      this.motivoAnulacion = '';
      this.reversarEfecto = false;
      this.showConfirmModal = true;
    },

    cancelarConfirmacion() {
      this.showConfirmModal = false;
      this.confirmModalCargando = false;
      this.confirmModalPago = null;
      this.confirmModalAccion = null;
      this.motivoAnulacion = '';
      this.reversarEfecto = false;
    },

    async ejecutarAccionConfirmada() {
      if (this.confirmModalAccion) {
        this.confirmModalCargando = true;
        await this.confirmModalAccion(this.confirmModalPago);
        this.confirmModalCargando = false;
        this.cancelarConfirmacion();
      }
    },

    abrirModalAnular(pago) {
      this.abrirModalConfirmacion({
        tipo: 'anular',
        titulo: 'Anular Pago',
        subtitulo: 'Esta acción no se puede deshacer',
        mensaje: `¿Estás seguro de anular el pago #${pago.idPago}?`,
        icon: 'mdi:cancel',
        color: 'bg-gradient-to-r from-red-600 to-pink-600',
        buttonColor: 'bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700',
        botonTexto: 'Anular Pago',
        pago: pago,
        accion: this.anularPagoConfirmado
      });
    },

    abrirModalToggleEstado(pago) {
      if (pago.estado?.toLowerCase() === 'anulado') return; // No permitir cambiar estado de anulados
      
      const nuevoEstado = pago.estado?.toLowerCase() === 'completado' ? 'pendiente' : 'completado';
      
      this.abrirModalConfirmacion({
        tipo: 'toggle-estado',
        titulo: 'Cambiar Estado del Pago',
        subtitulo: `Cambiar de "${pago.estado}" a "${this.getNuevoEstado(pago.estado)}"`,
        mensaje: `¿Estás seguro de cambiar el estado del pago #${pago.idPago}?`,
        icon: pago.estado?.toLowerCase() === 'completado' ? 'mdi:clock-outline' : 'mdi:check-circle',
        color: pago.estado?.toLowerCase() === 'completado' ? 'bg-gradient-to-r from-yellow-600 to-orange-600' : 'bg-gradient-to-r from-green-600 to-emerald-600',
        buttonColor: pago.estado?.toLowerCase() === 'completado' ? 'bg-gradient-to-r from-yellow-600 to-orange-600 hover:from-yellow-700 hover:to-orange-700' : 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700',
        botonTexto: 'Cambiar Estado',
        pago: pago,
        accion: this.toggleEstadoPago
      });
    },

    // ========== MÉTODOS DE TOAST ==========
    mostrarExito(mensaje) {
      this.toast.success(mensaje, { timeout: 3000 });
    },

    mostrarError(mensaje) {
      this.toast.error(mensaje, { timeout: 5000 });
    },

    mostrarAdvertencia(mensaje) {
      this.toast.warning(mensaje, { timeout: 4000 });
    },

    // ========== MÉTODOS DE FORMATEO ==========
    formatNumber(numero, decimales = 2) {
      if (numero === null || numero === undefined) return '0';
      return new Intl.NumberFormat('es-VE', {
        minimumFractionDigits: decimales,
        maximumFractionDigits: decimales
      }).format(numero);
    },

    formatDate(fechaISO, completo = true) {
      if (!fechaISO) return '';
      try {
        const fecha = new Date(fechaISO);
        const opciones = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        };
        if (completo) {
          opciones.hour = '2-digit';
          opciones.minute = '2-digit';
        }
        return fecha.toLocaleDateString('es-VE', opciones);
      } catch (error) {
        return fechaISO;
      }
    },

    formatTime(fechaISO) {
      if (!fechaISO) return '';
      try {
        const fecha = new Date(fechaISO);
        return fecha.toLocaleTimeString('es-VE', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
      } catch (error) {
        return '';
      }
    },

    getEstadoClass(estado) {
      switch (estado?.toLowerCase()) {
        case 'completado':
          return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
        case 'pendiente':
          return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200';
        case 'anulado':
          return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200';
        default:
          return 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
      }
    },

    getEstadoBgClass(estado) {
      switch (estado?.toLowerCase()) {
        case 'completado':
          return 'bg-green-50 dark:bg-green-900/20';
        case 'pendiente':
          return 'bg-yellow-50 dark:bg-yellow-900/20';
        case 'anulado':
          return 'bg-red-50 dark:bg-red-900/20';
        default:
          return 'bg-gray-50 dark:bg-gray-900/20';
      }
    },

    getEstadoTextClass(estado) {
      switch (estado?.toLowerCase()) {
        case 'completado':
          return 'text-green-600 dark:text-green-400';
        case 'pendiente':
          return 'text-yellow-600 dark:text-yellow-400';
        case 'anulado':
          return 'text-red-600 dark:text-red-400';
        default:
          return 'text-gray-600 dark:text-gray-400';
      }
    },

    getEstadoIcon(estado) {
      switch (estado?.toLowerCase()) {
        case 'completado':
          return 'mdi:check-circle';
        case 'pendiente':
          return 'mdi:clock-outline';
        case 'anulado':
          return 'mdi:cancel';
        default:
          return 'mdi:help-circle';
      }
    },

    getNuevoEstado(estadoActual) {
      if (estadoActual?.toLowerCase() === 'completado') return 'Pendiente';
      if (estadoActual?.toLowerCase() === 'pendiente') return 'Completado';
      return estadoActual;
    },

    getNuevoEstadoClass(estadoActual) {
      if (estadoActual?.toLowerCase() === 'completado') return 'text-yellow-600 dark:text-yellow-400';
      if (estadoActual?.toLowerCase() === 'pendiente') return 'text-green-600 dark:text-green-400';
      return '';
    },

    getTipoPagoClass(tipo) {
      switch (tipo) {
        case 'Venta':
          return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
        case 'Cuota':
          return 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200';
        case 'Recepción':
          return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
        default:
          return 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
      }
    },

    // ========== MÉTODOS DE FILTROS ==========
    handleFilterChange() {
      this.currentPage = 1;
    },

    handleSearch: debounce(function() {
      this.currentPage = 1;
    }, 300),

    clearFilters() {
      this.searchQuery = '';
      this.filterStatus = 'all';
      this.filterMetodoPago = 'all';
      this.filterMoneda = 'all';
      this.filtroFechaDesde = '';
      this.filtroFechaHasta = '';
      this.sortBy = 'fecha_desc';
      this.currentPage = 1;
    },

    // ========== MÉTODOS DE REPORTES ==========
    generarReporteGeneral() {
      this.reporteTitulo = 'REPORTE GENERAL DE PAGOS';
      this.reporteSubtitulo = `Todos los pagos (${this.pagos.length})`;
      this.reportePagos = this.pagos;
      this.reporteVista = 'lista';
      this.showReportModal = true;
    },

    generarReportePorFiltro(tipoFiltro, tituloPersonalizado = null) {
      let pagosFiltrados = [];
      const hoy = new Date();
      
      if (tipoFiltro === 'completado') {
        pagosFiltrados = this.pagos.filter(p => p.estado?.toLowerCase() === 'completado');
      } else if (tipoFiltro === 'pendiente') {
        pagosFiltrados = this.pagos.filter(p => p.estado?.toLowerCase() === 'pendiente');
      } else if (tipoFiltro === 'anulado') {
        pagosFiltrados = this.pagos.filter(p => p.estado?.toLowerCase() === 'anulado');
      } else if (tipoFiltro === 'hoy') {
        pagosFiltrados = this.pagos.filter(p => {
          const fechaPago = new Date(p.fecha_pago);
          return fechaPago.toDateString() === hoy.toDateString();
        });
      } else if (tipoFiltro === 'semana') {
        const inicioSemana = new Date(hoy);
        inicioSemana.setDate(hoy.getDate() - hoy.getDay());
        inicioSemana.setHours(0, 0, 0, 0);
        
        pagosFiltrados = this.pagos.filter(p => {
          const fechaPago = new Date(p.fecha_pago);
          return fechaPago >= inicioSemana;
        });
      } else if (tipoFiltro === 'mes') {
        const inicioMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
        
        pagosFiltrados = this.pagos.filter(p => {
          const fechaPago = new Date(p.fecha_pago);
          return fechaPago >= inicioMes;
        });
      }
      
      if (pagosFiltrados.length === 0) {
        this.toast.warning('No hay pagos que coincidan con este filtro');
        return;
      }
      
      this.reporteTitulo = tituloPersonalizado || `REPORTE DE PAGOS: ${tipoFiltro.toUpperCase()}`;
      this.reporteSubtitulo = `Filtro: ${tipoFiltro}`;
      this.reportePagos = pagosFiltrados;
      this.reporteVista = 'lista';
      this.showReportModal = true;
    },

    closeReportModal() {
      this.showReportModal = false;
      this.reportePagos = [];
      this.reporteVista = 'lista';
    },

    imprimirReporte() {
      // Aquí implementarías la lógica de impresión
      this.toast.info('Función de impresión en desarrollo');
    },

    // ========== MÉTODOS DEL MODAL ==========
    openCreateModal() {
      this.resetForm();
      this.showModal = true;
    },

    abrirModalVerDetalles(pago) {
      this.detallePago = null;
      this.showDetallesModal = true;
      this.cargarDetallesCompletos(pago.idPago);
    },

    closeModal() {
      this.showModal = false;
      this.resetForm();
    },

    closeDetallesModal() {
      this.showDetallesModal = false;
      this.detallePago = null;
    },

    resetForm() {
      this.form = {
        tipoReferencia: null,
        idReferencia: null,
        monto: null,
        moneda: 'USD',
        referencia: '',
        descripcion: '',
        idMetodoPago: '',
        fecha_pago: '',
        idFuenteTasa: null
      };
    },

    // ========== MÉTODOS CRUD ==========
    async crearPago() {
      if (!this.isFormValid) return;

      this.saving = true;
      try {
        // Construir el objeto de pago según la estructura de tu API
        const pagoData = {
          monto: parseFloat(this.form.monto),
          moneda: this.form.moneda,
          referencia: this.form.referencia || undefined,
          descripcion: this.form.descripcion || undefined,
          idMetodoPago: parseInt(this.form.idMetodoPago),
          idUsuario: 1, // Aquí deberías obtener el ID del usuario actual
          idFuenteTasa: this.form.idFuenteTasa ? parseInt(this.form.idFuenteTasa) : null
        };

        // Asignar la referencia según el tipo seleccionado
        if (this.form.tipoReferencia === 'venta') {
          pagoData.idVenta = parseInt(this.form.idReferencia);
        } else if (this.form.tipoReferencia === 'cuota') {
          pagoData.idCuota = parseInt(this.form.idReferencia);
        } else if (this.form.tipoReferencia === 'recepcion') {
          pagoData.idRecepcionEquipo = parseInt(this.form.idReferencia);
        }

        // Agregar fecha si se especificó
        if (this.form.fecha_pago) {
          pagoData.fecha_pago = new Date(this.form.fecha_pago).toISOString();
        }

        console.log('Creando pago con datos:', pagoData);

        const result = await crearPago(pagoData);

        if (result.success) {
          await this.loadData();
          this.closeModal();
          this.mostrarExito('¡Pago registrado exitosamente!');
        } else {
          throw new Error(result.error || 'Error al registrar el pago');
        }
      } catch (error) {
        console.error('Error al crear pago:', error);
        this.mostrarError(error.message || 'Error al registrar el pago');
      } finally {
        this.saving = false;
      }
    },

    async anularPagoConfirmado(pago) {
      try {
        const anularData = {
          idPago: pago.idPago,
          motivo: this.motivoAnulacion,
          reversar_efecto_en_cuota: this.reversarEfecto,
          idUsuario: 1 // Aquí deberías obtener el ID del usuario actual
        };

        const result = await anularPago(pago.idPago, anularData);

        if (result.success) {
          await this.loadData();
          this.mostrarExito('¡Pago anulado exitosamente!');
        } else {
          throw new Error(result.error || 'Error al anular el pago');
        }
      } catch (error) {
        console.error('Error al anular pago:', error);
        this.mostrarError(error.message || 'Error al anular el pago');
      }
    },

    async toggleEstadoPago(pago) {
      try {
        const nuevoEstado = this.getNuevoEstado(pago.estado);
        
        const updateData = {
          idPago: pago.idPago,
          idEstadoPago: nuevoEstado === 'Completado' ? 1 : 2, // Ajusta según tus IDs
          referencia: pago.referencia,
          descripcion: pago.descripcion
        };

        const result = await actualizarPago(pago.idPago, updateData);

        if (result.success) {
          await this.loadData();
          this.mostrarExito(`¡Estado cambiado a ${nuevoEstado}!`);
        } else {
          throw new Error(result.error || 'Error al cambiar el estado');
        }
      } catch (error) {
        console.error('Error al cambiar estado:', error);
        this.mostrarError('Error al cambiar el estado del pago');
      }
    }
  }
};
</script>

<style scoped>
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.fade-in {
  animation: fadeIn 0.3s ease-out;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.dark ::-webkit-scrollbar-track {
  background: #374151;
}

.dark ::-webkit-scrollbar-thumb {
  background: #6b7280;
}

.dark ::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

@media (max-width: 768px) {
  button {
    min-height: 44px;
  }
  
  input, select, textarea {
    font-size: 16px !important;
  }
}
</style>